<!-- <div class="hideNavBar"></div> -->
<!-- Modal for work order status change -->
<div class="modal-container"  [ngClass]="theme.getThemeClass()">
  <article>
    <h4 class="title">{{ "editWorkOrder" | translate }}</h4>
    <table class="title">
      <tr>
        <td><h6>Order Id: </h6></td>
        <td><h6>{{workOrderModalService.selectedWorkOrder.work_order_id}}</h6></td>
      </tr>
      <tr>
        <td><h6>Device: </h6></td>
        <td><h6>{{workOrderModalService.selectedWorkOrder.thing_name}}</h6></td>
      </tr>
    </table>
    @if (workOrderModalService.showStatusModal) {
    <label class="title">{{ "workOrderStatus" | translate }}</label>

    <div class="select-div">
      <select
        class="form-control ng-select"
        name="status"
        [(ngModel)]="selectedStatus"
        (change)="workOrderModalService.statusChange(selectedStatus)"
      >
        @for (status of statusArray; track status.value) {
          <option class="table-option" [value]="status.value">{{ status.label | translate }}</option>
        }
      </select>
    </div>
  }
  
    <!-- Modal for work order deadline date change -->
    @if (workOrderModalService.showDeadlineDateModal) {
      <label class="title">{{ "deadline" | translate }}</label>
      <div class="date-picker-div">
        <!-- <input matInput readonly [matDatepicker]="picker" (dateChange)="workOrderModalService.deadlineDateChange(selectedDate)" [(ngModel)]="selectedDate" class="form-control" placeholder="{{convertTimestamp(selectedDate)}}">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker> -->
        <input
          type="datetime-local"
          class="form-control"
          aria-label="Deadline"
          aria-describedby="deadline-addon"
          [(ngModel)]="selectedDate"
          (input)="workOrderModalService.deadlineDateChange(selectedDate)"
        />
      </div>
    }
    <!-- Modal for work order description change -->
    @if (workOrderModalService.showDescriptionModal) {
      <label class="title">{{ "workOrderDescription" | translate }}</label>
      <textarea [(ngModel)]="selectedDescription" class="text-description" (input)="workOrderModalService.descriptionChange(selectedDescription)"></textarea>
    }
    <!-- Modal for work order comments change -->
    @if (workOrderModalService.showCommentModal) {
      <label class="title">{{ "writeComments" | translate }}</label>
      <textarea [(ngModel)]="selectedComment" class="text-description" (input)="workOrderModalService.commentChange(selectedComment)"></textarea>
    }

    <nav class="button-bar">
      <button (click)="workOrderModalService.close()" [ngClass]="theme.getThemeClass()" type="button" class="btn btn-primary btn-block btnCancel fixed-size">{{ 'clientcreateFormBtnCancel' | translate }}</button>
      <button [ngClass]="theme.getThemeClass()" (click)="workOrderModalService.submitChange()" type="button" class="btn btn-primary btn-block btnCreate fixed-size">{{ 'clienteditFormBtnUpdateClient' | translate }}</button>
    </nav>
  </article>
</div>
  
